import { FC } from 'react';
import styled from 'styled-components';
import { fonts } from 'ui/theme';
import { TABLE_COLUMN_WIDTHS, ORDERED_TABLE_COLUMNS } from '../constants';

const TableWrapper = styled.div`
  align-items: stretch;
  display: grid;
  font-family: ${fonts.sansSerif};
  grid-template-columns: ${ORDERED_TABLE_COLUMNS.map(
    (id) => `[col-${id}] ${TABLE_COLUMN_WIDTHS[id]}`,
  ).join(' ')};
`;

export const testIds = {
  table: 'segmentation-lrt-table',
};

export const Table: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <TableWrapper data-test={testIds.table}>{children}</TableWrapper>
);
